import '../../../index.scss'
import './News.scss'

import React from 'react'

export const News = () => {
    return (<>
        <section className='news'>
        <div
            class="fb-page"
            data-href="https://www.facebook.com/ipea215/"
            data-tabs="timeline"
            data-width=""
            data-height=""
            data-small-header="false"
            data-adapt-container-width="true"
            data-hide-cover="false"
            data-show-facepile="true"
        >
            <blockquote
                cite="https://www.facebook.com/ipea215/"
                class="fb-xfbml-parse-ignore"
            >
                    <a href="https://www.facebook.com/ipea215/">IPEA 215 Raúl Scalabrini Ortiz</a>
            </blockquote>
        </div>
        </section>
    </>)
}